// extracted by mini-css-extract-plugin
export default {"newcomer":"newcomer___oGA97","Steps":"Steps___tEl2v"};